/**
 * F&O Trade Analysis service — talks to `/api/v1/fno-analysis/*` (see
 * `app.api.v1.fno_analysis`). Read-only analysis/decision-support only —
 * never places, previews, or modifies a broker order. Separate from
 * `strategyRecommendationService`/`optionsDashboardService` because this is
 * its own independently-versioned feature/response shape, matching this
 * codebase's "one Axios module per domain" convention.
 */

import api from "@/services/api";
import type { FnoBacktestReport, FnoTradeAnalysisResponse } from "@/types";

export const fnoAnalysisService = {
  async getFnoTradeAnalysis(symbol: string): Promise<FnoTradeAnalysisResponse> {
    const { data } = await api.get<FnoTradeAnalysisResponse>(`/fno-analysis/${symbol}`);
    return data;
  },

  async getFnoBacktest(symbol: string, startDate: string, endDate: string): Promise<FnoBacktestReport> {
    const { data } = await api.get<FnoBacktestReport>(`/fno-analysis/${symbol}/backtest`, {
      params: { start_date: startDate, end_date: endDate },
    });
    return data;
  },
};

export default fnoAnalysisService;
